import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlashBox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.5 1.66667C2.03977 1.66667 1.66667 2.03977 1.66667 2.5V12.5C1.66667 12.9602 2.03977 13.3333 2.5 13.3333H12.5C12.9602 13.3333 13.3333 12.9602 13.3333 12.5V2.5C13.3333 2.03977 12.9602 1.66667 12.5 1.66667H2.5ZM0 2.5C0 1.11929 1.11929 0 2.5 0H12.5C13.8807 0 15 1.11929 15 2.5V12.5C15 13.8807 13.8807 15 12.5 15H2.5C1.11929 15 0 13.8807 0 12.5V2.5ZM10.8333 6.66667H8.33333V2.5L4.16667 8.33333H6.66667V12.5L10.8333 6.66667Z",
		fill: "#4A4D53"
	})]
});
const ForwardRef = forwardRef(SvgFlashBox);
export { ForwardRef as ReactComponent };
